<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <el-pagination
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >{{ $t('button.create') }}</el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
    >
      <el-table-column
        prop="id"
        label="ID"
        width="100"
      />

      <el-table-column
        :label="$t('table.title')"
        prop="title"
        min-width="200"
      />

      <el-table-column
        prop="image"
        label="Banner Image"
        width="200"
      >
        <template slot-scope="scope">
          <img :src="scope.row.image" width="180"/>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('table.createdTime')"
        width="180"
      >
        <template #default="{ row }">
          <i class="el-icon-time" />
          <span style="margin-left:5px;">{{ row.create_date }}</span>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('table.enable')"
        width="60"
      >
        <template #default="{ row }">
          <div class="status-row">
            <el-switch
              v-model="row.status"
              :disabled="row.isLoading"
              @change="handleStatusChange(row)"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('table.action')"
        fixed="right"
        align="center"
        width="60"
      >
        <template #default="{ row }">
          <div class="button-group">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleEditButtonClick(row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import BannerService from '../../api/banner'

export default {
  name: 'BannerList',
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleCreate() {
      this.$router.push({ path: '/banner/create' })
    },
    handleStatusChange(banner) {
      if (banner.status) {
        this.toggleEnableBanner(banner)
      } else {
        this.$confirm(this.$t('message.disableBanner'), this.$t('common.warning'), {
          confirmButtonText: this.$t('button.ok'),
          cancelButtonText: this.$t('button.cancel'),
          type: 'warning',
        }).then(() => {
          // Update server
          this.toggleEnableBanner(banner)
        }).catch(() => {
          banner.status = true
        })
      }
    },
    handleEditButtonClick(row) {
      this.$router.push({ path: `/banner/edit/${row.id}` })
    },
    async getList() {
      this.isLoading = true
      try {
        const response = await BannerService.getList(this.listQuery.page, this.listQuery.size)
        const { data: newList, pagination } = response
        this.list = newList.map(item => ({
          ...item,
          isLoading: false,
          status: !!item.status, // convert 1,0 to boolean so can use v-model
        }))
        this.listQuery.total = parseInt(pagination.total_items, 0)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async toggleEnableBanner(banner) {
      banner.isLoading = true
      try {
        await BannerService.updateDetail({
          status: Number(banner.status),
        }, banner.id)
      } catch (error) {
        banner.status = !banner.status
      } finally {
        banner.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

::v-deep {
  .el-table__row {
    .cell {
      overflow: visible;
    }
  }
}

</style>
